import { Navigate } from "react-router-dom";
import { useAuth } from "./auth";

const ADMIN_ROLES = new Set(["admin", "super_admin"]);
const SUPER_ROLES = new Set(["super_admin"]);

export default function AuthGuard({ children, adminOnly = false, superAdminOnly = false }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-ink-950">
                <div className="flex items-center gap-3 text-fog-400 font-mono text-xs">
                    <span className="w-2 h-2 bg-periwinkle-500 rounded-full animate-pulse-soft" />
                    Cargando…
                </div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if (superAdminOnly && !SUPER_ROLES.has(user.role)) return <Navigate to="/" replace />;
    if (adminOnly && !ADMIN_ROLES.has(user.role)) return <Navigate to="/" replace />;
    return children;
}
